import React from "react";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.reportData;
        const pluckingReportData = this.props.pluckingReportData;
        const sundryReportData = this.props.sundryReportData;
        const integrationLogReport = this.props.integrationLogReport;
        const totalValues = this.props.totalValues;
        return (
            <div className="p-2">
                <h3><center><u>Integration Log Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division == undefined ? "All Divisions" : searchData.division}</div>
                    <div className="col"><b>Field: </b> {searchData.field == undefined ? "All Fields" : searchData.field}</div>
                    {searchData.attendanceType == 3 && (
                        <div className="col"><b>Block: </b> {searchData.block == undefined ? "All Blocks" : searchData.block}</div>
                    )}
                    <div className="col"><b>Attendance Type: </b> {searchData.attendanceType == 1 ? 'Plucking' : searchData.attendanceType == 2 ? 'Sundry' : 'RSM'}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                {integrationLogReport === "3" ?
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Date
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Division
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Field
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Block
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Employee No
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Employee Name
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Integration Status
                                    </TableCell>
                                    <TableCell align="right" style={{ fontWeight: "bold" }}>
                                        Quantity (Kg)
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportData.map((row) => (
                                    <TableRow key={row.employeeCode}>
                                        <TableCell component="th" scope="row">
                                            {new Date(row.attendanceDate).toLocaleDateString('en-CA')}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.division}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.field}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.block}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.employeeID}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.employeeName}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.isSentToNavition == true ? 'Yes' : 'No'}
                                        </TableCell>
                                        <TableCell component="th" scope="row" align="right">
                                            {row.quantity}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={7} align="left" style={{ fontWeight: "bold" }}>Total</TableCell>
                                    <TableCell component="th" scope="row" align="right">{totalValues.totalRSMQuantity}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer> : null}
                {integrationLogReport === "2" ?
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Date
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Division
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Field
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Job
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Employee No
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Employee Name
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Integration Status
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sundryReportData.map((row) => (
                                    <TableRow key={row.employeeCode}>
                                        <TableCell component="th" scope="row">
                                            {new Date(row.attendanceDate).toLocaleDateString('en-CA')}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.division}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.field}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.job}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.employeeID}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.employeeName}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.isSentToNavition == true ? 'Yes' : 'No'}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer> : null}
                {integrationLogReport === "1" ?
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Date
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Division
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Field
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Job
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Employee No
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Employee Name
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Integration Status
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                        Cash
                                    </TableCell>
                                    <TableCell align="right" style={{ fontWeight: "bold" }}>
                                        Quantity
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pluckingReportData.map((row) => (
                                    <TableRow key={row.employeeCode}>
                                        <TableCell component="th" scope="row">
                                            {new Date(row.attendanceDate).toLocaleDateString('en-CA')}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.division}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.field}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.job}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.employeeID}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.employeeName}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.isSentToNavition == true ? 'Yes' : 'No'}
                                        </TableCell>
                                        <TableCell component="th" scope="row" align="right">
                                            {row.cashWork == true ? 'Yes' : 'No'}
                                        </TableCell>
                                        <TableCell component="th" scope="row" align="right">
                                            {row.quantity}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={8} align="left" style={{ fontWeight: "bold" }}>Total</TableCell>
                                    <TableCell component="th" scope="row" align="right">{totalValues.totalPluckingQuantity}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    : null}
            </div>
        );
    }
}